import Vue from 'vue'
import Router from 'vue-router'
import official from '@/components/pc'
import home from '@/components/home'
import about from '@/components/about'
import agreement from '@/components/agreement'
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/off',
        name: 'off',
        component: official,
        children: [
            { path: 'home', component: home },
            { path: 'about', component: about },
            { path: 'agreement', component: agreement },
        ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js